export default "__VITE_PUBLIC_ASSET__f5c97f96__"